module.exports = __webpack_public_path__ + "img/promo-banner.f4bd498c.gif";